import { render, staticRenderFns } from "./TextEdit.vue?vue&type=template&id=05de7830&scoped=true"
import script from "./TextEdit.vue?vue&type=script&lang=js"
export * from "./TextEdit.vue?vue&type=script&lang=js"
import style0 from "./TextEdit.vue?vue&type=style&index=0&id=05de7830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de7830",
  null
  
)

export default component.exports